import React from 'react';
import { Box, Typography } from '@mui/material';

const Brand = ({ dark = false, compact = false }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
    <Box
      sx={{
        width: 30,
        height: 30,
        flex: '0 0 auto',
        display: 'grid',
        placeItems: 'center',
        borderRadius: 2,
        bgcolor: '#14b8a6',
        color: '#06302c',
        fontSize: 12,
        fontWeight: 800
      }}
    >
      XS
    </Box>
    {!compact && (
      <Typography sx={{ color: dark ? '#fff' : '#17212b', fontWeight: 700, fontSize: 15, whiteSpace: 'nowrap' }}>
        Excel to SFCC
      </Typography>
    )}
  </Box>
);

export default Brand;
